var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguage = function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.288 12.52a1.02 1.02 0 0 0-1.12.387l-1 1.44a.93.93 0 0 0-.116.837l1 2.88a1 1 0 0 0 .948.656h3c.335 0 .647-.16.832-.428l2-2.88a.93.93 0 0 0 .11-.857.98.98 0 0 0-.654-.595zm-.184 2.502.318-.458 2.997.863-.954 1.373h-1.744z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23 12c0 5.832-4.925 10.56-11 10.56S1 17.832 1 12 5.925 1.44 12 1.44 23 6.168 23 12m-2 0c0 4.772-4.03 8.64-9 8.64S3 16.772 3 12c0-.987.172-1.936.49-2.82l3.937 2.646c.442.297 1.05.204 1.373-.21l1.344-1.72 4.262-1.819a.96.96 0 0 0 .59-.782l.345-3.32C18.657 5.248 21 8.362 21 12m-7.615-8.538A9.4 9.4 0 0 0 12 3.36c-3.22 0-6.045 1.624-7.636 4.065L7.781 9.72l.92-1.177a1 1 0 0 1 .393-.301l3.969-1.694z",
    clipRule: "evenodd"
  })));
};
export default SvgLanguage;